import { useDispatch, TypedUseSelectorHook, useSelector } from 'react-redux'

import { AppDispatch, StoreRootState } from '../store'

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<StoreRootState> = useSelector
